
      import ZoomOut from './zoom-out.vue'
      import type { App, Plugin } from 'vue'

      export const ZoomOutPlugin: Plugin = {
        install(app: App) {
          app.component('ZoomOut', ZoomOut)
        },
      }
      export { ZoomOut }
      